var map = {
	"./illinois/colors.css": 3750,
	"./neutral/colors.css": 5506,
	"./professional/colors.css": 2156,
	"themes/illinois/colors.css": 3750,
	"themes/neutral/colors.css": 5506,
	"themes/professional/colors.css": 2156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4211;